import React from 'react'
import { successtick } from "../../constants/Images";
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
export default function Joinsuccess() {
    const [auctionname, setAuctionname] = useState(localStorage.getItem('cjoined'))
    const [playerName, setPlayerName] = useState(localStorage.getItem('cjoined_player_name'))
    const [playerMobno, setPlayerMobno] = useState(localStorage.getItem('cjoined_player_mobno'))
    const [helplineMob, setHelplineMob] = useState(localStorage.getItem('cjoined_helpline_mob'))
    const [helplineName, setHelplineName] = useState(localStorage.getItem('cjoined_helpline_name'))
    const [helplineEntries, setHelplineEntries] = useState([])

    // Auto scroll to top when component mounts + load helpline list
    useEffect(() => {
        window.scrollTo(0, 0);
        try {
            const stored = localStorage.getItem('cjoined_helpline_list');
            if (stored) {
                const parsed = JSON.parse(stored);
                setHelplineEntries(Array.isArray(parsed) ? parsed : []);
            } else {
                setHelplineEntries([]);
            }
        } catch (_) {
            setHelplineEntries([]);
        }
    }, []);
    
    return (
        <div className='joinsuccess' style={{ minHeight: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '40px 20px' }}>
            <div>
                <h3>
                    <span className='sucauc' style={{ display: 'block', marginBottom: '10px', fontSize: '2rem', fontWeight: 'bold' }}>
                        {playerName} {playerMobno && `(${playerMobno})`}
                    </span>
                    You have successfully joined <span className='sucauc'>{auctionname}</span>
                </h3>
            </div>
            <div>
                <img src={successtick} alt="" /> 
            </div>
            {(helplineEntries && helplineEntries.length > 0) ? (
                <div style={{ marginTop: '20px', fontSize: '17px', color: '#4a5568', textAlign: 'left', maxWidth: '480px' }}>
                    {/* <style>{`
                        .joinsuccess-hl-entry { display: flex; flex-direction: row; align-items: center; gap: 8px; flex-wrap: wrap; margin: 8px 0; margin-left: 24px; }
                        @media (max-width: 768px) { .joinsuccess-hl-entry { flex-direction: column; align-items: flex-start; gap: 4px; } }
                    `}</style>
                    <p style={{ margin: '0 0 12px 0', fontWeight: '600' }}>
                        <span style={{ marginRight: '8px' }}>📞</span> Need Help :
                    </p> */}
                    {helplineEntries.map((entry, index) => (
                        <div key={index} className="joinsuccess-hl-entry">
                            <strong style={{ color: '#2d3748' }}>{entry.name || ''}</strong>
                            <a
                                href={`tel:${String(entry.mobile || '').replace(/[\s\-\(\)]/g, '')}`}
                                style={{ color: '#718096', textDecoration: 'none', fontWeight: '500' }}
                            >
                                {entry.mobile || ''}
                            </a>
                        </div>
                    ))}
                </div>
            ) : (helplineMob || helplineName) && (
                <div style={{ marginTop: '20px', fontSize: '18px', color: '#333' }}>
                    <p style={{ margin: '5px 0' }}>
                        <strong>Helpline No.:</strong> {helplineMob} {helplineName && `(${helplineName})`}
                    </p>
                </div>
            )}
            {localStorage.getItem('user') &&
            <div className='joinback' ><Link to='/dashboard'><button className='joinbackbtn'>Go to Dashboard</button></Link></div>
            }
            {/* <button>Back</button> */}
        </div>
    )
}
